module.exports = function() {

  return {
    template: '<div class="page-header"><div ng-transclude></div></div>',
    restrict: 'E',
    replace: true,
    transclude: true
  };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/pageHeader.js
 ** module id = 149
 ** module chunks = 1
 **/